export class ListInventoryResourceIdentifiersResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<ResourceIdentifiers>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryResourceIdentifiersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
